import {
  APP_SETTING_DELETE_PAGE_SNAPSHOT_BEGIN,
  APP_SETTING_DELETE_PAGE_SNAPSHOT_SUCCESS,
  APP_SETTING_DELETE_PAGE_SNAPSHOT_FAILURE,
  APP_SETTING_DELETE_PAGE_SNAPSHOT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deletePageSnapshot(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_PAGE_SNAPSHOT_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/page-snapshots/${uuid}`,
        config,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_DELETE_PAGE_SNAPSHOT_SUCCESS,
              data: args.uuid,
            });
            toast.success('Page Snapshot Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_DELETE_PAGE_SNAPSHOT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_PAGE_SNAPSHOT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeletePageSnapshotError() {
  return {
    type: APP_SETTING_DELETE_PAGE_SNAPSHOT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_PAGE_SNAPSHOT_BEGIN:
      return {
        ...state,
        deletePageSnapshotPending: true,
        deletePageSnapshotError: null,
      };

    case APP_SETTING_DELETE_PAGE_SNAPSHOT_SUCCESS:
      return {
        ...state,
        deletePageSnapshotPending: false,
        deletePageSnapshotError: null,
        pageSnapshots: state.pageSnapshots.filter((e) => e.uuid !== action.data),
      };

    case APP_SETTING_DELETE_PAGE_SNAPSHOT_FAILURE:
      return {
        ...state,
        deletePageSnapshotPending: false,
        deletePageSnapshotError: action.data.error,
      };

    case APP_SETTING_DELETE_PAGE_SNAPSHOT_DISMISS_ERROR:
      return {
        ...state,
        deletePageSnapshotError: null,
      };

    default:
      return state;
  }
}
